import { invalidAccountParser } from '../notificationdetails/invalidAccountParser';
import { alreadyFlatteningParser } from './alreadyFlatteningParser';
import { candlesBackGreaterThan1Parser } from './candlesBackGreaterThan1Parser';
import { cannotConfirmOrderCancelledParser } from './cannotConfirmOrderCancelledParser';
import { cannotUpdateTargetParser } from './cannotUpdateTargetParser';
import { entryContradictsTradePlanDirectionParser } from './entryContradictsTradePlanDirectionParser';
import { inPositionParser } from './inPositionParser';
import { invalidMarketPeriodParser } from './invalidMarketPeriodParser';
import { invalidSymbolParser } from './invalidSymbolParser';
import { liquidtyWarningParser } from './liquidityWarningParser';
import { missingDataParser } from './missingDataParser';
import { noLimitPriceParser } from './noLimitPriceParser';
import { noPositionParser } from './noPositionParser';
import { notEnoughBuyingPowerParser } from './notEnoughBuyingPowerParser';
import { notOnEtbListParser } from './notOnEtbListParser';
import { orderErrorParser } from './orderErrorParser';
import { orderModificationOutsideOfTradePlanParser } from './orderModificationOutsideOfTradePlanParser';
import { orderQtyMoreThanPositionSizeParser } from './orderQtyMoreThanPositionSizeParser';
import positionQtyMismatchParser from './positionQtyMismatchParser';
import { priceFiltersTargetsParser } from './priceFiltersTargetsParser';
import { priceFiltersTriggerCandleParser } from './priceFiltersTriggerCandleParser';
import { priceFiltersTriggerPriceParser } from './priceFiltersTriggerPriceParser';
import { priceOutsideOfOptionRangeFilter } from './priceOutsideOfOptionRangeFilter';
import { restartTradePlanParser } from './restartTradePlanParser';
import { savedConfigurationMigrationParser } from './savedConfigurationMigrationParser';
import { startTimeAfterMarketPeriod } from './startTimeAfterMarketPeriod';
import { symbolDoesNotExistParser } from './symbolDoesNotExistParser';
import { tacticCreationParser } from './tacticCreationParser';
import { tacticTriggerParser } from './tacticTriggerParser';
import { targetHitButNegativePnlParser } from './targetHitButNegativePnlParser';
import { tightSpreadCentsParser } from './tightSpreadCentsParser';
import { tightSpreadPctParser } from './tightSpreadPctParser';
import { tooManySymbolsParser } from './tooManySymbolsParser';
import { tradePlanPnlUpdateParser } from './tradePlanPnlUpdateParser';
import { workOrderSafetyNetParser } from './workOrderSafteyNetParser';
import { zeroOrderQtyParser } from './zeroOrderQtyParser';

/*
 * idk if the below is correct syntax or anything, just making this file for documentaiton purposes
 */
const statusParsers = {
  //null means the statusDetails object will be empty
  TACTIC_TRIGGERED: tacticTriggerParser,
  WORK_ORDER_SAFETY_NET: workOrderSafetyNetParser,
  TIGHT_SPREAD_CENTS: tightSpreadCentsParser,
  TIGHT_SPREAD_PCT: tightSpreadPctParser,
  NO_SELECTABLE_OPTIONS: null, //all potential options filtered out
  NO_OPTION_QUOTES: null, //the option u are trying to trade has no quotes for today, so bid/ask is probably very inaccurate
  RESTART_TRADE_PLAN: restartTradePlanParser,
  TRADE_PLAN_PNL_UPDATE: tradePlanPnlUpdateParser,
  NOT_ON_ETB_LIST: notOnEtbListParser,
  ORDER_LIQUIDITY_WARNING: liquidtyWarningParser,
  PRICE_OUTSIDE_OF_OPTION_RANGE: priceOutsideOfOptionRangeFilter,
  TARGET_HIT_BUT_NEGATIVE_PNL: targetHitButNegativePnlParser,
  TOKEN_ISSUE: null, //api token not working, prob need to log back into tradier
  CANNOT_BE_LONG_AND_SHORT: null, //if there is an issue with a config that would make long and short be true at same time, which is not possible (such as a market order long and short)
  NO_TRADING_ON_PREMARKET_CANDLES: null, //the B.E does not currently calculate candles outside of regular trading hours
  ALREADY_USED_TRADEPLAN_ID: null, //speaks for itself, this would be a system error
  MARKET_NOT_OPEN_TODAY: null, //a tradeplan was entered while market was closed
  ENTRY_CONTRADICTS_TRADE_PLAN_DIRECTION:
    entryContradictsTradePlanDirectionParser,
  CANNOT_CONFIRM_ORDER_CANCELLED: cannotConfirmOrderCancelledParser,
  TOO_MANY_SYMBOLS: tooManySymbolsParser,
  IN_POSITION: inPositionParser,
  START_TIME_AFTER_MARKET_PERIOD: startTimeAfterMarketPeriod,
  NO_POSITION: noPositionParser,
  MISSING_DATA: missingDataParser,
  ORDER_QTY_MORE_THAN_POSITION_SIZE: orderQtyMoreThanPositionSizeParser,
  ZERO_ORDER_QUANTITY: zeroOrderQtyParser,
  NO_LIMIT_PRICE: noLimitPriceParser,
  INVALID_SYMBOL: invalidSymbolParser,
  INVALID_ACCOUNT: invalidAccountParser,
  PRICE_FILTERS_TARGETS: priceFiltersTargetsParser,
  PRICE_FILTERS_TRIGGER_CANDLE: priceFiltersTriggerCandleParser,
  TACTIC_CREATION_ERROR: tacticCreationParser,
  SYMBOL_DOES_NOT_EXIST: symbolDoesNotExistParser,
  ORDER_ERROR: orderErrorParser,
  NOT_ENOUGH_BUYING_POWER: notEnoughBuyingPowerParser,
  SAVED_CONFIGURATION_MIGRATION: savedConfigurationMigrationParser,
  PRICE_FILTERS_TRIGGER_PRICE: priceFiltersTriggerPriceParser,
  POSITION_QTY_MISMATCH: positionQtyMismatchParser,
  ALREADY_FLATTENING: alreadyFlatteningParser, //
  ORDER_MODIFICATION_OUTSIDE_TRADE_PLAN:
    orderModificationOutsideOfTradePlanParser,
  CANDLES_BACK_GREATER_THAN_ONE: candlesBackGreaterThan1Parser,
  NO_OPENING_PRICE_USE_CURRENT_QUOTE_INSTEAD:
    null /*this occurs in some of the tactics that rely on knowing the opening price
    // (such as candle trigger). If we cant retreive this price, we use the current bid ask instead and send this notification*/,
  CANNOT_UPDATE_TARGET: cannotUpdateTargetParser,
  INVALID_MARKET_PERIOD: invalidMarketPeriodParser,
  MULTI_SYMBOL_OPTION_PLAN: null,
  MULTIPLEXER_ALREADY_HELD:
    null /*(explanation, this means that one tradeplan has locked out another tradeplan 
        from acting. The case it is currently being used is by 1 tradeplan that is tracking two separate emas. 
        If one ema causes an entry, we dont let the other one enter as well)
    */,
};

export const parseStatusDetails = (status, statusDetails) => {
  const parser = statusParsers[status];
  if (parser) {
    return parser(statusDetails);
  } else return null;
};
